import { createSlice } from "@reduxjs/toolkit";
import { checklistDocumentUplodOptionsAction } from "../../actions/settings/settingsActions";

const settings = {
  settings: [],
  loading: false,
};

const settingSlice = createSlice({
  name: "Settings",
  initialState: settings,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(checklistDocumentUplodOptionsAction.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(
        checklistDocumentUplodOptionsAction.fulfilled,
        (state, action) => {
          state.settings = action.payload?.data;
          state.loading = false;
          return state;
        },
      )
      .addCase(
        checklistDocumentUplodOptionsAction.rejected,
        (state, action) => {
          state.loading = false;
        },
      ),
});

export default settingSlice.reducer;
